import { Fragment } from "react";
import { flexRender } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { Table as BaseTable } from "reactstrap";
import SubContent from "./SubContent";
import Loading from "../../../../../components/Loaders/Loading";

function Table({ table, params = {}, isMyOvertime }) {
    const { t } = useTranslation();
    const { loading, totalItems } = table.options;

    return (
        <div className="timesheet-overtimes-table mb-0">
            <BaseTable
                className="align-items-center table-flush m-0 p-0"
                hover
            >
                <thead className="thead-light" style={{ zIndex: 5 }}>
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                                <th
                                    key={header.id}
                                    colSpan={header.colSpan}
                                // style={{
                                //     width: header.getSize(),
                                //     maxWidth: header.getSize(),
                                //     minWidth: header.getSize(),
                                // }}
                                >
                                    {header.isPlaceholder
                                        ? null
                                        : flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="999">
                                <div className="d-flex justify-content-center">
                                    <Loading />
                                </div>
                            </td>
                        </tr>
                    ) : totalItems === 0 ? (
                        <tr>
                            <td colSpan="999">
                                <div className="d-flex justify-content-center">
                                    {t("no-data")}
                                </div>
                            </td>
                        </tr>
                    ) : table.getRowModel().rows.map((row) => {
                        return (
                            <Fragment key={row.id}>
                                <tr
                                    style={{
                                        background: row.getIsExpanded() ? "#fff7ed" : "",
                                    }}
                                >
                                    {row.getVisibleCells().map((cell) => (
                                        <td
                                            key={cell.id}
                                            className="p-2"
                                        // style={{
                                        //     width: cell.column.getSize(),
                                        //     maxWidth: cell.column.getSize(),
                                        //     minWidth: cell.column.getSize(),
                                        // }}
                                        >
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                            )}
                                        </td>
                                    ))}
                                </tr>

                                {row.getIsExpanded() && (
                                    <tr className="p-0 m-0">
                                        <td
                                            className="p-2 m-0"
                                            colSpan={row.getVisibleCells().length}
                                            style={{ background: "#f6f6f6" }}
                                        >
                                            <SubContent
                                                rowId={row.id}
                                                ids={row.original.ids}
                                                params={params}
                                                user={row.original}
                                                isMyOvertime={isMyOvertime}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </Fragment>
                        )
                    })}
                </tbody>
            </BaseTable>
        </div>
    );
}

export default Table;
